import { render } from "./PagamentoBoletoSucesso.vue?vue&type=template&id=2e5f7f5c"
import script from "./PagamentoBoletoSucesso.vue?vue&type=script&lang=js"
export * from "./PagamentoBoletoSucesso.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__